import React, { createContext, useContext, useState, useEffect } from 'react';

const DevModeContext = createContext({ devMode: false, toggleDevMode: () => {} });

export function DevModeProvider({ children }) {
  const [devMode, setDevMode] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'D') {
        e.preventDefault();
        setDevMode(prev => !prev);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <DevModeContext.Provider value={{ devMode, toggleDevMode: () => setDevMode(p => !p) }}>
      {devMode && (
        <div
          onClick={() => setDevMode(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            background: '#ff6b35',
            color: '#fff',
            textAlign: 'center',
            padding: '5px 8px',
            fontSize: 12,
            fontWeight: 700,
            fontFamily: 'monospace',
            cursor: 'pointer',
            letterSpacing: 1,
            userSelect: 'none',
          }}
        >
          ⚙ DEV MODE · Press ⌘⇧D (Mac) or Ctrl+Shift+D to toggle · Click to close
        </div>
      )}
      {children}
    </DevModeContext.Provider>
  );
}

export const useDevMode = () => useContext(DevModeContext);
